import React, { useEffect, useState } from "react";
import { MainWrapper } from "../../component/MainWrapper";
import { TopBar } from "../../component/TopBar";
import { FormattedMessage } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { useAuth } from "app/pages/module/auth";
import { fetchContractor } from "sr/helpers/apiFunctions/contractor/fetchContractor";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { ContractorTab } from "./components/ContractorTab";
import { Location } from "./components/Location";
import { General } from "./components/General";
import { JobType } from "./components/JobType";
import { WorkOrders } from "./components/WorkOrders";
import { useDispatch, useSelector } from "react-redux";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { AppDispatch } from "sr/redux/store";
import { getUserFullProfile } from "sr/utils/api/user/user";
import { OnboardingChecklist } from "./components/OnboardingChecklist";
import { BackgroundCheck } from "./components/BackgroundCheck";
import { RootState } from "sr/redux/store";

export const ContractorDetails = () => {
  const [id, setId] = useState<any>();
  const [customerLocations, setCustomerLocations] = useState([]);
  const [userId, setuserId] = useState();
  const [buttonLoader, setButtonLoader] = useState(true);
  const [data, setdata] = useState<any>([]);
  const [loader, setLoader] = useState(true);
  const [tab, settab] = useState("General");
  const [showOnboardingChecklist, setShowOnboardingChecklist] = useState(false);
  const [requiredChecklist, setRequiredChecklist] = useState([]);
  const { userType } = useAuth();
  const supervisorData = useSelector((item: any) => item?.supervisor?.data);
  const appSettingsData = useSelector((state: RootState) => state.appSettings.data);
  const showBackgroundCheck =
    userType === "company" &&
    appSettingsData?.companysContractorCheckrEnable === true &&
    appSettingsData?.checkr_enable === true;
  const dispatch = useDispatch<AppDispatch>();
  const TabHandle = (data: any) => {
    settab(data);
  };
  useEffect(() => {
    if (userId && userType === "supervisor") {
      if (!supervisorData) {
        dispatch(fetchSupervisor({ id: userId }));
      }
    }
  }, [userId, userType, dispatch]);
  useEffect(() => {
    const { user_id } = getUserDetails();
    setuserId(user_id);
  }, []);

  const params = useParams();
  useEffect(() => {
    const { id } = params;
    setId(id);
  }, [params]);

  const loadContractor = async (id) => {
    await fetchContractor({
      userType: userType,
      id: id,
      setData: setdata,
      setLoader: setLoader,
    });
  };
  useEffect(() => {
    if (id) {
      loadContractor(id);
    }
    // setButtonLoader(false);
  }, [id]);

  useEffect(() => {
    if (!showBackgroundCheck && tab === "Background check") {
      settab("General");
    }
  }, [showBackgroundCheck, tab]);

  useEffect(() => {
    const loadProfile = async () => {
      const response = await getUserFullProfile();
      const profile = response?.data?.user_type_detail;
      setShowOnboardingChecklist(
        profile?.isAllowedOnBordingSubmission === true,
      );
      setRequiredChecklist(profile?.requiredOnBordingChecklist || []);
      setButtonLoader(false);
    };
    loadProfile();
  }, []);

  return (
    <MainWrapper>
      {buttonLoader && <LoaderFullScreen />}
      <div className="bg-white py-3">
        <TopBar
          title={
            <FormattedMessage
              id="RECRUITER.SCHEDULEWORKORDER.INPUT.CONTRACTOR.TITLE"
              defaultMessage="Contractor"
            />
          }
          postButton={
            userType === "company" ||
            (userType === "supervisor" &&
              supervisorData?.access?.contractor_management?.add_contractor) ? (
              <Link
                to="/new-contractor"
                className="rounded-lg font-bold bg-[#ff39b3] px-5 py-3  text-white cursor-pointer hover:bg-navy"
              >
                <FormattedMessage
                  id="RECRUITER.WORK.ORDER.CONTRACTOR.ADD.BTN"
                  defaultMessage="Add Contractor"
                />
              </Link>
            ) : (
              <div className="hidden"></div>
            )
          }
          className="px-10"
        ></TopBar>
        <div className="px-10">
          <div>
            <div className="flex items-center space-x-4 mb-5">
              <Link to={`/contractor`}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="text-[#0078ae] w-5 h-5 cursor-pointer"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15.75 19.5L8.25 12l7.5-7.5"
                  />
                </svg>
              </Link>
              <div>
                <h2 className="">
                  {data?.first_name} {data?.last_name}
                </h2>
                <Link to={`/contractor`}>
                  <p className="text-base  text-[#0078ae]">
                    {" "}
                    <FormattedMessage
                      id="RECRUITER.SUPERVISOR.BACKBUTTON"
                      defaultMessage="Back"
                    />
                  </p>
                </Link>
              </div>
            </div>

            <ContractorTab
              tab={tab}
              TabHandle={TabHandle}
              showOnboardingChecklist={showOnboardingChecklist}
              showBackgroundCheck={showBackgroundCheck}
            ></ContractorTab>
          </div>
          {tab === "General" && <General data={data}></General>}
          {tab === "Onboarding checklist" && showOnboardingChecklist && (
            <OnboardingChecklist
              contractorId={id}
              requiredChecklist={requiredChecklist}
              onBoardingStatus={data?.onBoardingStatus || "pending"}
              value={data?.onBoardingChecklistCheck}
              onSaved={() => loadContractor(id)}
            />
          )}
          {tab === "Background check" && showBackgroundCheck && id && (
            <BackgroundCheck contractorId={id} setLoader={setButtonLoader} />
          )}

          {tab === "Location" && (
            <Location data={data} loadContractor={loadContractor}></Location>
          )}
          {tab === "Jobtype" && <JobType></JobType>}
          {tab === "Work Orders" && <WorkOrders></WorkOrders>}
        </div>
      </div>
    </MainWrapper>
  );
};
